import { useTranslation } from "react-i18next";
import { createFormContext } from "@mantine/form";
import { ClientBilling, ClientBillingInput } from "src/graphql/generated/graphql";

export const parseClientBillingInput = (clientBilling: ClientBilling): ClientBillingInput => {
    return {
        name: clientBilling?.name || "",
        email: clientBilling?.email || "",
        cin: clientBilling?.cin || "",
        tin: clientBilling?.tin || "",
        address: {
            country: clientBilling?.address?.country || null,
            postalCode: clientBilling?.address?.postalCode || "",
            city: clientBilling?.address?.city || "",
            line1: clientBilling?.address?.line1 || "",
            line2: clientBilling?.address?.line2 || "",
        },
    };
};

export const [ClientBillingFormProvider, useClientBillingFormContext, useForm] =
    createFormContext<ClientBillingInput>();

export const useClientBillingForm: typeof useForm = (values) => {
    const { t } = useTranslation(["common"]);

    return useForm({
        ...values,
        validate: (values) => ({
            name: !(values?.name?.length > 0) ? t("client_error_missingbillingname") : null,
            email: !(values?.name?.length > 0) ? t("client_error_invalidbillingemail") : null,
            cin: !(values?.cin?.length > 0) ? t("client_error_invalidbillingcin") : null,
            "address.country": !values?.address?.country ? t("client_error_missingbillingcountry") : null,
            "address.city": !(values?.address?.city?.length > 0) ? t("client_error_missingbillingcity") : null,
            "address.postalCode": !(values?.address?.postalCode?.length > 0)
                ? t("client_error_missingbillingpostalcode")
                : null,
            "address.line1": !(values?.address?.line1?.length > 0) ? t("client_error_missingbillingline1") : null,
        }),
    });
};
